Array.from(document.querySelectorAll('[data-cms-user-content]')).forEach(
	content => {
		Array.from(content.querySelectorAll('.image > a')).forEach(
			imageLink => {
				if (/\.(?:jpe?g|png|gif|webp)$/.test(imageLink.href)) {
					imageLink.dataset.lightbox = 'image'
				}
			}
		)
	}
)
